import theme from '../../styles/theme';
export const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
// in rem
export const fontSizes = {
    large: 48,
    medium: 32,
    small: 24,
};
export const ICON_SPACING = {
    large: theme.spacing.x4,
    medium: theme.spacing.x4,
    small: theme.spacing.x3,
};
// in rem
export const ICON_HOVER_GAP = 2;
export const ICON_BORDER_WIDTH = 1;
export const ICON_SELECTED_BORDER_WIDTH = 2;
export const disabledOpacity = 0.3;
